import { render, staticRenderFns } from "./createPrivacySetting.vue?vue&type=template&id=253c6e2a&"
import script from "./createPrivacySetting.vue?vue&type=script&lang=js&"
export * from "./createPrivacySetting.vue?vue&type=script&lang=js&"
import style0 from "./createPrivacySetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports